import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {
  Box,
  Button,
  CardContent,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Radio,
  RadioGroup,
  Stack,
  List,
  ListItem,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery
} from '@mui/material';

import { ToolOutlined, InfoCircleOutlined } from '@ant-design/icons';

// third party
import * as Yup from 'yup';
import { Formik } from 'formik';
import { PatternFormat } from 'react-number-format';

import { useNavigate } from "react-router";

import IconButton from '../../../../Components/@extended/IconButton';
import MainCard from '../../../../Components/MainCard';
import {DeleteOutlined, EyeOutlined, EyeInvisibleOutlined, PlusOutlined, LoginOutlined} from '@ant-design/icons';
import {Auth} from "aws-amplify";
import AnimateButton from "../../../../Components/@extended/AnimateButton";
import ReportCard from "../../../../Components/cards/statistics/ReportCard";

const TabPayment = ({ card }) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const customer_portal_url = process.env.REACT_APP_XERO_PLAN_PAGE_URL;
  const {selected_subscription} = useSelector((state) => state.xeroconnection);
  const handleManageSubscriptionClick = (event) => {
    console.log(event);
    if (selected_subscription===null){
      window.open(customer_portal_url, '_blank');
    }
    else {
      window.open(selected_subscription['subscription_url'], '_blank');
    }
  }

    return (
        <MainCard title="Billing Management">
          <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} spacing={2}>
              <List sx={{py: 0}}>
                <ListItem divider={true}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <ReportCard primary={selected_subscription?.num_of_users_limit} secondary="Subscription Maximum Users" color='red' iconPrimary={InfoCircleOutlined} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ReportCard primary={selected_subscription?.list_of_users.length} secondary="Subscription Activated Users" color='orange' iconPrimary={InfoCircleOutlined} />
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem divider={true}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <Stack spacing={0.5}>
                        <Typography color="black">Manage Subscription</Typography>
                        <AnimateButton>
                          <Button size="large"
                            onClick={(event) => handleManageSubscriptionClick(event)}
                            endIcon={<ToolOutlined />}
                            variant="contained"
                          >Manage Subscription
                          </Button>
                        </AnimateButton>
                        <FormHelperText>Click the button above to be redirected to a page to manage your subscription. We use Stripe as a partner to manage your subscriptions. The link will provide you with your invoice history, customer information, payment methods, and subscription cancellations.</FormHelperText>
                      </Stack>
                    </Grid>
                  </Grid>
                </ListItem>
              </List>
            </Grid>
          </Grid>
          </CardContent>
        </MainCard>
    )
}

export default TabPayment;